module.exports = __webpack_public_path__ + "static/pic06-1e0c6bd96fcd78b5625ac698e3d2850c.png";